import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MyAccount } from '../modules/MyAccount';

export const Route = createFileRoute('/my-account')({
  component: RouteComponent,
  validateSearch: z.object({
    tab: z.enum(['profile', 'preferences']).optional(),
  }),
  head: () => ({
    meta: [{ title: 'My Account' }],
  }),
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  return <MyAccount initialTab={tab} />;
}
